import { RotateCcw, Trash2 } from 'lucide-react';
import type { SwipeAction } from '@shared/ui/primitives/SwipeableRow';
import type { AccessInvite } from './api';
import { isCancellableInvite } from './inviteFilters';

export interface InviteSwipeHandlers {
  onAgain: (invite: AccessInvite) => void;
  onCancel: (invite: AccessInvite) => void;
}

/** Swipe actions for past / cancelled invites — re-invite only. */
export function buildPastInviteSwipeActions(
  invite: AccessInvite,
  handlers: Pick<InviteSwipeHandlers, 'onAgain'>,
): SwipeAction[] {
  return [
    {
      key: 'reinvite',
      label: 'Again',
      icon: <RotateCcw className="h-4 w-4" strokeWidth={1.75} />,
      variant: 'neutral',
      onClick: () => handlers.onAgain(invite),
    },
  ];
}

/** Swipe actions shared by the access list and home widget. */
export function buildInviteSwipeActions(
  invite: AccessInvite,
  handlers: InviteSwipeHandlers,
): SwipeAction[] {
  const actions: SwipeAction[] = [
    {
      key: 'reinvite',
      label: 'Again',
      icon: <RotateCcw className="h-4 w-4" strokeWidth={1.75} />,
      variant: 'neutral',
      onClick: () => handlers.onAgain(invite),
    },
  ];
  if (isCancellableInvite(invite)) {
    actions.push({
      key: 'cancel',
      label: 'Cancel',
      icon: <Trash2 className="h-4 w-4" strokeWidth={1.75} />,
      variant: 'danger',
      onClick: () => handlers.onCancel(invite),
    });
  }
  return actions;
}
